import { createContext } from "react";

const CatPeriodicidadContext = createContext();

export default CatPeriodicidadContext;
